export const API_DEFAULT_CARBON_REMOVAL_PROJECT_ID = 11241;
